import React, { useEffect } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import moment from "moment";
import defectCardsStore from "../../../../store/defectCards";

import { Spinner } from "../../../../ui-kit";
import SmsStatus from "../smsStatus";
import Constants from "../../../../constants/Common";

import styles from "./DefectNotifyStatus.module.scss";
interface DefectNotifyStatusProps {
  defectId: string;
}

const DefectNotifyStatus: React.FC<DefectNotifyStatusProps> = observer(
  ({ defectId }) => {
    const {
      notificationsListsAreLoading,
      notificationsListsDataPaginator,
      notificationsListsData,
    } = defectCardsStore;

    useEffect(() => {
      defectCardsStore.getNotificationsLists(defectId);
    }, [
      notificationsListsDataPaginator.page,
      notificationsListsDataPaginator.perPage,
    ]);

    const data = toJS(notificationsListsData[0]);

    if (notificationsListsAreLoading.value) {
      return (
        <div className={styles.defectNotifyStatus}>
          <Spinner />
        </div>
      );
    }

    return (
      <>
        {data ? (
          <div className={styles.defectNotifyStatus}>
            <SmsStatus
              label="Отправлено"
              value={
                moment(data?.dtSend).isValid()
                  ? moment(data.dtSend).format(Constants.dateTimeFormat)
                  : "-"
              }
            />
            <SmsStatus
              label="Группа для рассылки"
              value={data?.groupName || "-"}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  },
);

export default DefectNotifyStatus;
